module.exports = __webpack_public_path__ + "hashed/41ebc50536dee9e095ec59c46e498d4a.svg";